import { gql } from '@apollo/client';

export const FETCH_POSTS_QUERY = gql`
  query getPosts{
    getPosts{
      id body createdAt username likeCount commentCount 
      likes {
        username
      }
      comments {
        id username createdAt body 
      }
    }
  }
`;

export const CREATE_POST_MUTATION = gql`
  mutation createPost($body: String!){
    createPost(body: $body){
      id body createdAt username commentCount likeCount 
      likes {
        id username createdAt
      }
      comments{
        id body username createdAt
      }
    }
  }
`;

export const LOGIN_USER = gql`
  mutation login($username: String!, $password: String!){
    login(username: $username, password: $password){
      id email username token createdAt
    }
  }
`;

export const REGISTER_USER =gql`
  mutation register($username: String!, $email: String!, $password: String!, $confirmPassword: String!){
    register(registerInput: {username: $username, email: $email, password: $password, confirmPassword: $confirmPassword}){
      id email username createdAt token
    }
  }
`;

export const LIKE_POST_MUTATION = gql`
  mutation likePost($postId: ID!){
    likePost(postId: $postId){
      id likeCount
      likes {
        id username
      }
    }
  }
`;

export const FETCH_POST_QUERY = gql`
  query($postId: ID!) {
    getPost(postId: $postId) {
      id body createdAt username likeCount commentCount
      likes {
        username
      }
      comments {
        id username createdAt body
      }
    }
  }
`;

export const DELETE_POST_MUTATION = gql`
  mutation deletePost($postId: ID!){
    deletePost(postId: $postId)
  }
`;


export const SUBMIT_COMMENT_MUTATION = gql`
  mutation($postId: ID!, $body: String!){
    createComment(postId: $postId, body: $body){
      id commentCount comments{
        id body createdAt username 
      }
    }
  }
`;

export const DELETE_COMMENT_MUTATION = gql`
mutation deleteComment($postId: ID!, $commentId: ID!){
  deleteComment(postId: $postId, commentId: $commentId){
    id comments{
      id username createdAt body
    }
    commentCount
  }
}
`;